import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export class Loader {
  protected counter$ = new BehaviorSubject<number>(0);

  get value(): number {
    return this.counter$.getValue();
  }

  increase(): void {
    this.setCounter(this.value + 1);
  }

  decrease(): void {
    this.setCounter(this.value - 1);
  }

  reset(): void {
    this.setCounter(0);
  }

  ping(): void {
    this.setCounter(this.value);
  }

  isLoading(): boolean {
    return this.value > 0;
  }

  getWhenStop(): Observable<any> {
    return this.counter$.asObservable().pipe(filter(() => !this.isLoading()));
  }

  protected setCounter(value: number): void {
    if (value < 0) {
      this.counter$.next(0);
    } else {
      this.counter$.next(value);
    }
  }
}
